// Non-React scripts
import './features/nav-menu';
import './features/search';
import './features/editor-search';
import './features/social-share';
import './features/scroll-indicator';
import './features/form-builder';
import 'core-js/features/url-search-params';
import './utils/lazy-load-background-images';

// React scripts
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import Helmet from 'react-helmet';
import 'material-icons/iconfont/material-icons.css';

// expose styled-components for server side rendering
import { ServerStyleSheet } from 'styled-components';

import ButtonLink from './framework/shared/ButtonLinkComponent';
import FlexibleBannerComponent from './framework/components/FlexibleBannerComponent';
import FeaturedBusinessSolutions from './framework/components/FeaturedBusinessSolutionsComponent';
import FeaturedCaseStudyComponent from './framework/components/FeaturedCaseStudyComponent';
import FeaturedInsightComponent from './framework/components/FeaturedInsightComponent';
import TiledLinkSection from './framework/components/TiledLinkSectionComponent';
import SvgFromFilePath from './framework/shared/SvgFromFilePath';
import WidgetSpacingWrapper from './framework/shared/WidgetSpacingWrapper';
import ImageWithTextComponent from './framework/components/ImageWithTextComponent';
import LocalNavigationItem from './framework/components/LocalNavigationItemComponent';
import BannerWithIconsComponent from './framework/components/BannerWithIconsComponent';
import CareersLocationsComponent from './framework/components/CareersLocationsComponent';
import QuoteCardComponent from './framework/components/QuoteCardComponent';
import TabAccordionComponent from './framework/components/TabAccordionComponent';
import CommunityInvolvementComponent from './framework/components/CommunityInvolvementComponent';
import LeadershipTeamOverview from './framework/components/LeadershipTeamOverviewComponent';
import KeyContactsComponent from './framework/components/KeyContactsComponent';
import HeroComponent from './framework/components/HeroComponent';
import Accordion from './framework/shared/Accordion';
import RelatedResources from './framework/components/RelatedResources';
import HomeHeroComponent from './framework/components/HomeHeroComponent';
import TrendingTopicsComponent from './framework/components/TrendingTopicsComponent';
import LocationDetail from './framework/components/Location/LocationDetail';
import ServiceLandingTabs from './framework/components/ServiceLanding/ServiceLandingTabs';
import TransactionsLanding from './framework/components/TransactionsLanding';
import InsightsSectionComponent from './framework/components/InsightsSectionComponent';
import GlobalLocationsComponent from './framework/components/GlobalLocationsComponent';
import EventsWebinarsSliderComponent from './framework/components/EventsWebinarsSliderComponent';
import EventWebinarDetail from './framework/components/EventWebinarDetail/EventWebinarDetail';
import InsightLandingComponent from './framework/components/InsightLandingComponent';
import GlobalEquityMatrixComponent from './framework/components/GlobalEquityMatrixComponent';
import TransactionCarouselComponent from './framework/components/TransactionCarouselComponent';
import TrendingTopicsCarouselComponent from './framework/components/TrendingTopicsCarouselComponent';
import TrendingTopicInsightList from './framework/components/TrendingTopic/TrendingTopicInsightList';
import EventWebinarLandingInsightList from './framework/components/EventWebinarLanding/EventWebinarLandingInsightList';
import OrderedPageSelectorObserver from './features/ordered-page-selector-observer';
import SubscriptionComponent from './framework/components/SubscriptionComponent';
import ExpandableSidebarComponent from './framework/components/ExpandableSidebarComponent';
import FeaturedEventComponent from './framework/components/FeaturedEventComponent';
import RegisteredUserSubscriptionManagementForm from './framework/components/RegisteredUserSubscriptionManagement/RegisteredUserSubscriptionManagementForm';
import LocationsLanding from './framework/components/LocationsLanding/LocationsLanding';
import SiteSearchPage from './framework/components/Search/SiteSearchPage';
import HeaderSearch from './framework/components/Search/HeaderSearch';
import SearchPreviewComponent from './framework/components/SearchPreviewComponent';
import ChangePasswordComponent from './framework/components/UserManagement/ChangePasswordComponent';
import ResetPasswordRequest from './framework/components/UserManagement/ResetPasswordRequestComponent';
import LoginComponent from './framework/components/UserManagement/LoginComponent';
import RegistrationComponent from './framework/components/UserManagement/RegistrationComponent';
import AllianceLocationsLanding from './framework/components/AllianceLocationsLanding/AllianceLocationsLanding';
import ManageAccountForm from './framework/components/UserManagement/ManageAccountForm';
import { IndustryCard } from './framework/components/cards/IndustryCard';
import IndustryList from './framework/components/Industries/IndustryList';
import ReadMoreCard from './framework/components/cards/ReadMoreCard';
import ReadMoreCardList from './framework/components/cards/ReadMoreCardList';

global.Styled = { ServerStyleSheet };

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;
global.Helmet = Helmet;

global.ButtonLink = ButtonLink;
global.FlexibleBannerComponent = FlexibleBannerComponent;
global.FeaturedBusinessSolutions = FeaturedBusinessSolutions;
global.FeaturedCaseStudyComponent = FeaturedCaseStudyComponent;
global.FeaturedInsightComponent = FeaturedInsightComponent;
global.TiledLinkSection = TiledLinkSection;
global.SvgFromFilePath = SvgFromFilePath;
global.WidgetSpacingWrapper = WidgetSpacingWrapper;
global.ImageWithTextComponent = ImageWithTextComponent;
global.LocalNavigationItem = LocalNavigationItem;
global.BannerWithIconsComponent = BannerWithIconsComponent;
global.CareersLocationsComponent = CareersLocationsComponent;
global.QuoteCardComponent = QuoteCardComponent;
global.TabAccordionComponent = TabAccordionComponent;
global.Accordion = Accordion;
global.CommunityInvolvementComponent = CommunityInvolvementComponent;
global.LeadershipTeamOverview = LeadershipTeamOverview;
global.KeyContactsComponent = KeyContactsComponent;
global.HeroComponent = HeroComponent;
global.RelatedResources = RelatedResources;
global.HomeHeroComponent = HomeHeroComponent;
global.TrendingTopicsComponent = TrendingTopicsComponent;
global.LocationDetail = LocationDetail;
global.InsightsSectionComponent = InsightsSectionComponent;
global.ServiceLandingTabs = ServiceLandingTabs;
global.TransactionsLanding = TransactionsLanding;
global.GlobalLocationsComponent = GlobalLocationsComponent;
global.EventsWebinarsSlider = EventsWebinarsSliderComponent;
global.EventWebinarDetail = EventWebinarDetail;
global.InsightLandingComponent = InsightLandingComponent;
global.GlobalEquityMatrixComponent = GlobalEquityMatrixComponent;
global.EventWebinarDetail = EventWebinarDetail;
global.TransactionCarouselComponent = TransactionCarouselComponent;
global.TrendingTopicsCarouselComponent = TrendingTopicsCarouselComponent;
global.TransactionCarouselComponent = TransactionCarouselComponent;
global.TrendingTopicInsightList = TrendingTopicInsightList;
global.EventWebinarLandingInsightList = EventWebinarLandingInsightList;
global.FeaturedEvent = FeaturedEventComponent;
global.OrderedPageSelectorObserver = new OrderedPageSelectorObserver();
global.SubscriptionComponent = SubscriptionComponent;
global.ExpandableSidebarComponent = ExpandableSidebarComponent;
global.RegisteredUserSubscriptionManagementForm = RegisteredUserSubscriptionManagementForm;
global.LocationsLanding = LocationsLanding;
global.SiteSearchPage = SiteSearchPage;
global.HeaderSearch = HeaderSearch;
global.SearchPreview = SearchPreviewComponent;
global.ChangePasswordComponent = ChangePasswordComponent;
global.ResetPasswordRequestComponent = ResetPasswordRequest;
global.LoginComponent = LoginComponent;
global.RegistrationComponent = RegistrationComponent;
global.AllianceLocationsLanding = AllianceLocationsLanding;
global.ManageAccountForm = ManageAccountForm;
global.IndustryCard = IndustryCard;
global.IndustryList = IndustryList;
global.ReadMoreCard = ReadMoreCard;
global.ReadMoreCardList = ReadMoreCardList;
